/**
 * @file 表达式函数实现
 */
import { parseConditionIf, parseParam } from '../index';
import { PARAMETER_TYPE } from '../constant';

/**
 * 表达式函数
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const expressionFunction = async (func, customParamsList, customFunctionParams, instanceId) => {
  let expressionStr = await concatExpressions(_get(func, 'inParams'), customParamsList, customFunctionParams, instanceId);
  console.log("expressionFunction---------------",expressionStr,eval(`(${expressionStr})`));
  return eval(`(${expressionStr})`);
}

/**
 * 组装表达式
 * @param params
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const concatExpressions = async (params, customParamsList, customFunctionParams, instanceId) => {
  let parsedParams = [];
  const analyAft = await parseConditionIf(params, customParamsList, customFunctionParams, instanceId);
  for (let param of analyAft) {
    let value = await parseParam(param, customParamsList, customFunctionParams, instanceId);
    if (value === undefined) {
      parsedParams.push('"undefined"');
    } else {
      if (![PARAMETER_TYPE.OPERATOR, PARAMETER_TYPE.PRIORITY, PARAMETER_TYPE.LOGIC].includes(param.paramType) && typeof value === 'string') {

        value = value.replace(/"/g, '\\"');

        //除运算符、括号外的字符串类型参数需要加上引号
        parsedParams.push(`"${value}"`);
      } else {
        //表达式中对象类型的参数需要使用JSON.stringify转换
        parsedParams.push(typeof value === 'object' ? JSON.stringify(value) : value);
      }
    }
  }
  return parsedParams.join(' ');
}

/**
 * 表达式数组根据
 * @param arr
 * @returns
 */
export const splitByLogic = (arr) => {
  const result = [];
  let currentGroup = [];
  for (const item of arr) {
    if (item.paramType === PARAMETER_TYPE.LOGIC) {
      // 将当前组添加到结果中（如果不为空）
      if (currentGroup.length > 0) {
        result.push([...currentGroup]);
        currentGroup = [];
      }
      // 将逻辑项作为单独的数组添加到结果中
      result.push([item]);
    } else {
      // 将非逻辑项添加到当前组
      currentGroup.push(item);
    }
  }

  // 添加最后一组（如果有）
  if (currentGroup.length > 0) {
    result.push(currentGroup);
  }

  return result;
}

/**
 * 向下取整
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const mathFloor = async (func, customParamsList, customFunctionParams, instanceId) => {
  let num = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
  return Math.floor(num);
}

/**
 * 向上取整
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const mathCeil = async (func, customParamsList, customFunctionParams, instanceId) => {
  let num = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
  return Math.ceil(num);
}
